@if(isWebSite) {
  <header [class.mobile-off-overflow]="hamburger" class="header">
    @if(isDesktop$ | async) {
      <div class="header-wrap">
        <div class="header-logo">
          <a [routerLink]="['']">
            <img [src]="environment.LOGO_SITE" alt="logo" />
          </a>
        </div>
        <app-header-desktop-navigation [items]="webSiteItems"></app-header-desktop-navigation>
        <div class="header-controls d-flex justify-content-between align-items-center">
          <app-header-dropdown (logoutEvent)="logoutHandler()"
                               [phones]="phones"
                               [isLoanExist]="isLoanExist()"
          ></app-header-dropdown>
          <app-header-buttons></app-header-buttons>
        </div>
      </div>
    } @else {
      <div class="header-wrap">
        <div class="header-logo">
          <a [routerLink]="['']" class="header-logo__link">
            <img [src]="environment.LOGO_SITE" alt="logo" />
          </a>
        </div>
        <app-header-mobile-navigation
          (hamburgerEvent)="hamburgerEventHandler()"
          (itemClickEvent)="hamburgerEventHandler()"
          (logoutEvent)="logoutHandler()"
          [active]="hamburger"
          [env]="environment"
          [isLogged]="isLogged$ | async"
          [isMenu]="true"
          [isWebSite]="isWebSite"
          [items]="webSiteItems"
          [phones]="phones"
          [payment]="payment()"
        ></app-header-mobile-navigation>
        <div class="d-flex justify-content-between align-items-center">
          <app-header-buttons></app-header-buttons>
          <div (click)="hamburgerEventHandler()" [ngClass]="{ hamburger_active: hamburger }" class="ml-2 hamburger">
            <span class="hamburger__line"></span>
          </div>
        </div>
      </div>
    }
  </header>
} @else {
  <header [class.mb-64]="isStepsVisible && !hideStepper" class="header">
    <div class="header-wrap">
      <div class="header-inner d-flex align-items-center justify-content-between">
        <div [ngClass]="{ active: hamburger }" class="header-logo">
          <img [src]="environment.LOGO_SITE" alt="" class="header-logo-icon" height="100%" width="100%" />
        </div>

        @if(showReconnectLink()){
          <div class="reconnect-link">
            <button (click)="toReconnect()" class="reconnect-return-button">
              <img alt="" height="15" src="/assets/img/arrow-left.svg" width="40"/>
            </button>
          </div>
        } @else {
          <div class="header-content d-flex align-items-center justify-content-end">
            <div class="d-flex align-items-center">
              <app-header-dropdown (logoutEvent)="logoutHandler()"
                                   [phones]="phones"
                                   [isLoanExist]="isLoanExist()"
                                   [isLogoutVisible]="isLogoutVisible()"
              ></app-header-dropdown>
              @if (payment()?.visible && (isDesktop$ | async)) {
                <app-payment-button [payment]="payment()" type="small"></app-payment-button>
              }
            </div>
            @if (isLoanExist()) {
              <app-header-navigation
                (hamburgerEvent)="hamburgerEventHandler()"
                (logoutEvent)="logoutHandler()"
                [active]="hamburger"
                [env]="environment"
                [isLogged]="isLogged$ | async"
                [isMenu]="isMenu$ | async"
                [isMobile]="tabletWide$ | async"
                [navItems]="navItems"
                [phones]="phones"
                [payment]="payment()"
              ></app-header-navigation>
            }
          </div>
        }
      </div>
    </div>
    <div class="header-footer">
      <app-stepper-widget (onVisibleChange)="onStepsVisibleChange($event)" [hideStepper]="hideStepper" [steps]="steps"></app-stepper-widget>
    </div>
  </header>
}
